 <template>
  <div>
   <v-app-bar
      app
      color="white"
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <v-row align="center">
          <v-col cols="12">
              <div class="d-flex align-center" >
              <!-- <img :src="logoImg" alt="juzzap" height="48"/> -->
              <!-- <span class="ml-3 primary--text" style="font-weight:bold;font-size:22px;" >Juzzap</span> -->
              </div>
          </v-col>
        </v-row>

        </v-toolbar-title>

        <v-spacer></v-spacer>
      <v-menu offset-y v-if="$store.getters.user">
        <template v-slot:activator="{ on }">
          <v-avatar v-on="on" height="32" width="auto" rounded=false style="border-radius:0">
            <img :src="$user.userType=='agent'?$user.agent.photo:($user.userType=='business'?$user.business.logo_thumb:'')" :alt="$user.name" />
            <!-- <v-img :src="$user.userType=='agent'?$user.agent.photo:($user.userType=='business'?$user.business.logo_thumb:'')" ></v-img> -->
          </v-avatar>
        </template>
        <v-card tile>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <img :src="$user.userType=='agent'?$user.agent.photo:($user.userType=='business'?$user.business.logo_thumb:'')" :alt="$user.name" />
                <!-- <v-img :src="$user.userType=='agent'?$user.agent.photo:($user.userType=='business'?$user.business.logo_thumb:'')" :alt="$user.name" ></v-img> -->
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{JSON.parse($store.getters.user).name}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>
          <v-list>
            <v-list-item-group>
            <v-list-item >
              <v-list-item-content>
              <!-- <v-list-item-title @click="$router.push('/agent/dashboard')">Change Password</v-list-item-title> -->

              <v-list-item-title @click="$router.push({name:'changepass'})">{{$t('zz_change_password')}}</v-list-item-title>



              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-title @click="logout">{{$t('zz_logout')}}</v-list-item-title>
            </v-list-item>

            </v-list-item-group>
          </v-list>


        </v-card>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
    
        expand-on-hover
      v-model="drawer"
      clipped
      app
      :class="$user.userType=='agent' ? 'agdashboard' : '' "
    >
      <v-list dense>

        <v-list-item link @click="$router.push({name:'dashboardbusiness'})" class="home">
                        <v-list-item-action >
                          <v-icon>mdi-home-heart</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold text-uppercase">{{$t('zz_home')}}</v-list-item-title>
                        </v-list-item-content>
        </v-list-item>
        <v-list-group no-action>
          <template v-slot:activator>
              <v-list-item-action>
                            <v-icon>mdi-domain</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold text-uppercase">{{$t('zz_business_details')}}</v-list-item-title>
              </v-list-item-content>
          </template>

          <v-list-item link 
          @click="$router.push({name:'updatebusiness'})">
          
            <v-list-item-action>
                            <v-icon>mdi-card-account-details-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title   class="text-uppercase">{{$t('zz_profile')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link
          @click="$router.push({name:'businessstatics'})">
            <v-list-item-action>
                            <v-icon>mdi-chart-bar-stacked</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title  class="text-uppercase" >{{$t('zz_statistics')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link
          @click="$router.push({name:'apphelp'})">
            <v-list-item-action>
                            <v-icon>mdi-chart-bar-stacked</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title  class="text-uppercase" >App Help</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>


        <!--Food Item -->
        <v-list-group no-action >
          <template v-slot:activator>
              <v-list-item-action>
                            <v-icon>mdi-food-apple-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold text-uppercase">{{$t('zz_food_items')}}</v-list-item-title>
              </v-list-item-content>
          </template>


          <v-list-item link
          @click="$router.push({name:'createfooditem',params:{id:JSON.parse($store.getters.business).id}})"
          class="">
            <v-list-item-action>
                            <v-icon>mdi-plus-circle-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title  class="text-uppercase" >{{$t('zz_add_food_item')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link
          @click="$router.push({name:'businessfooditemlist'})"
          class="">
            <v-list-item-action>
                            <v-icon>mdi-table-cog</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title  class="text-uppercase" >{{$t('zz_food_table')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link
          @click="$router.push({name:'businessfoodlist'})"
          class=" ">
            <v-list-item-action>
                            <v-icon>mdi-drag-variant</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title  class="text-uppercase" >{{$t('zz_food_drag_and_drop')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link
         @click="$router.push({name:'courselist'})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-table-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title   class="text-uppercase">{{$t('zz_course_table')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
          

          <!-- <v-list-item link
          @click="$router.push({name:'food',params:{tag:JSON.parse($store.getters.business).businesscode}})"
          class="d-md-none d-sm-none">
            <v-list-item-action>
                            <v-icon>mdi-silverware-fork-knife</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title  >Food</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

        </v-list-group>

        <!--Food Course -->

      <!-- <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-action>
            <v-icon>mdi-clipboard-list-outline</v-icon>

          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title class="font-weight-bold text-uppercase">{{$t('zz_courses')}}</v-list-item-title>

          </v-list-item-content>
        </template>

        <v-list-item link @click="$router.push({name:'createcourse'})" class="">
          <v-list-item-action>
            <v-icon>mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase">{{$t('zz_create_course')}}</v-list-item-title>

          </v-list-item-content>
        </v-list-item>

        <v-list-item link
         @click="$router.push({name:'courselist'})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-table-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title   class="text-uppercase">{{$t('zz_course_table')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group> -->

      <!-- Drink Item-->
      <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-action>
            <v-icon>mdi-glass-cocktail</v-icon>
          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title class="font-weight-bold text-uppercase">{{$t('zz_drink_items')}}</v-list-item-title>

          </v-list-item-content>

        </template>

        <v-list-item link
         @click="$router.push({name:'createbusinessdrinkitem',params:{id:JSON.parse($store.getters.business).id}})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title   class="text-uppercase">{{$t('zz_add_drink_item')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item link
         @click="$router.push({name:'DrinkComponent',params:{id:JSON.parse($store.getters.business).id,dtype:'create'}})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title   class="text-uppercase">{{$t('zz_add_drink_item')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <!-- <v-list-item link
          @click="$router.push({name:'drink',params:{tag:JSON.parse($store.getters.business).businesscode}})"
          class="d-md-none d-sm-none">
          <v-list-item-action>
                          <v-icon>mdi-table-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  >Drink</v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->



        <v-list-item link
         @click="$router.push({name:'businessdrinklist'})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-table-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase" >{{$t('zz_drink_table')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link
         @click="$router.push({name:'drinkdragdroplist'})"
         class=" ">
          <v-list-item-action>
                          <v-icon>mdi-drag-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title   class="text-uppercase">{{$t('zz_food_drag_and_drop')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link
         @click="$router.push({name:'typelist'})"
         class=" ">
          <v-list-item-action>
                          <v-icon>mdi-drag-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title   class="text-uppercase">Type Table</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list-group>

      <!-- Retail Item-->
      <v-list-group no-action >
        <template v-slot:activator>
            <v-list-item-action>
                          <v-icon>mdi-tag-multiple-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold text-uppercase">{{$t('zz_retail_items')}}</v-list-item-title>
            </v-list-item-content>
        </template>

        <v-list-item link
         @click="$router.push({name:'createretailitem',params:{id:JSON.parse($store.getters.business).id}})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title   class="text-uppercase">{{$t('zz_add_retail_item')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link
         @click="$router.push({name:'retailitemlist'})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-table-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase" >{{$t('zz_retail_items_table')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link
         @click="$router.push({name:'retaillist'})"
         class=" ">
          <v-list-item-action>
                          <v-icon>mdi-drag-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title   class="text-uppercase">{{$t('zz_food_drag_and_drop')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$router.push({name:'createcategory'})" class="">
          <v-list-item-action>
            <v-icon>mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase">{{$t('zz_add_category')}}</v-list-item-title>

          </v-list-item-content>
        </v-list-item>

        <v-list-item link
         @click="$router.push({name:'categorylist'})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-table-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase" >{{$t('zz_category_table')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list-group>

      <!-- Retail Category-->
      <!-- <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-action>
            <v-icon>mdi-certificate-outline</v-icon>

          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title class="font-weight-bold text-uppercase">{{$t('zz_retail_category')}}</v-list-item-title>

          </v-list-item-content>
        </template>

        <v-list-item link @click="$router.push({name:'createcategory'})" class="">
          <v-list-item-action>
            <v-icon>mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase">{{$t('zz_add_category')}}</v-list-item-title>

          </v-list-item-content>
        </v-list-item>

        <v-list-item link
         @click="$router.push({name:'categorylist'})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-table-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase" >{{$t('zz_category_table')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group> -->

      <!-- Event-->
      <v-list-group no-action >
        <template v-slot:activator>
            <v-list-item-action>
                          <v-icon>mdi-calendar-range</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold text-uppercase">{{$t('zz_events')}}</v-list-item-title>
            </v-list-item-content>
        </template>

        <v-list-item link
         @click="$router.push({name:'addEvent',params:{id:JSON.parse($store.getters.business).id}})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title   class="text-uppercase">{{$t('zz_add_event')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link
         @click="$router.push({name:'eventLists'})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-table-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title   class="text-uppercase">{{$t('zz_event_table')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$router.push({name:'createeventcategory'})" class="">
          <v-list-item-action>
            <v-icon>mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase">{{$t('zz_add_category')}}</v-list-item-title>

          </v-list-item-content>
        </v-list-item>

      </v-list-group>

      <!-- Event Category-->
      <!-- <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-action>
            <v-icon>mdi-cube-unfolded</v-icon>

          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title class="font-weight-bold text-uppercase">{{$t('zz_event_category')}}</v-list-item-title>

          </v-list-item-content>
        </template>

        <v-list-item link @click="$router.push({name:'createeventcategory'})" class="">
          <v-list-item-action>
            <v-icon>mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase">{{$t('zz_add_category')}}</v-list-item-title>

          </v-list-item-content>
        </v-list-item>

        <v-list-item link
         @click="$router.push({name:'eventcategorylist'})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-table-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase" >{{$t('zz_category_table')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group> -->

      <!-- Department-->
      <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-action>
            <v-icon>mdi-human-greeting</v-icon>

          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title class="font-weight-bold text-uppercase">{{$t('zz_departments')}}</v-list-item-title>

          </v-list-item-content>
        </template>

        <v-list-item link @click="$router.push({name:'addDepartment'})" class="">
          <v-list-item-action>
            <v-icon>mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase">{{$t('zz_add_department')}}</v-list-item-title>

          </v-list-item-content>
        </v-list-item>

        <v-list-item link
         @click="$router.push({name:'departmentlist'})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-table-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase" >{{$t('zz_department_table')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$router.push({name:'addEmployee'})" class="">
          <v-list-item-action>
            <v-icon>mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase">{{$t('zz_add_employee')}}</v-list-item-title>

          </v-list-item-content>
        </v-list-item>

        <v-list-item link
         @click="$router.push({name:'employeeLists'})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-table-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase">{{$t('zz_employee_table')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <!-- Employee-->
      <!-- <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-action>
            <v-icon>mdi-human-greeting</v-icon>

          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title class="font-weight-bold text-uppercase">{{$t('zz_employees')}}</v-list-item-title>

          </v-list-item-content>
        </template>

        <v-list-item link @click="$router.push({name:'addEmployee'})" class="">
          <v-list-item-action>
            <v-icon>mdi-plus-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase">{{$t('zz_add_employee')}}</v-list-item-title>

          </v-list-item-content>
        </v-list-item>

        <v-list-item link
         @click="$router.push({name:'employeeLists'})"
         class="">
          <v-list-item-action>
                          <v-icon>mdi-table-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title  class="text-uppercase">{{$t('zz_employee_table')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group> -->





    </v-list>
    </v-navigation-drawer>
  </div>
 </template>
<script>
import Vue from "vue";

export default {

  data: () => ({
    drawer:null
  }),
  methods:{
     logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    }
  }

};

</script>
<style scoped>
.home-bg{
  background-color: #FE5800;
  color: white !important;
}


</style>